import { createApp } from "vue";
import { createPinia } from "pinia";
import { plugin, defaultConfig } from "@formkit/vue";

import "bootstrap";
import "@formkit/themes/genesis";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/App/scss/main.scss";

import App from "./App/App.vue";
import router from "./App/router/router";
import { initSentry } from "./App/services/MonitoringService";

const app = createApp(App);

if (!window.Cypress) initSentry(app);

app.use(plugin, defaultConfig);
app.use(createPinia());
app.use(router);

app.mount("#app");
